import semanticClassNames from '../VerticalMenu/VerticalMenu.semanticClassNames';
// ExpandableMenu is used on EDX as VerticalMenu on Classic, and also as the inner menu in mobile on both editors.
export default semanticClassNames;
